import React from 'react'
import './Footer.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram, faTwitter } from '@fortawesome/free-brands-svg-icons'

const Footer = () => {
    return (
        <footer className="professional-footer">
            <div className="footer-container">
                {/* Company Info Column */}
                <div className="footer-column">
                    <h3 className="footer-title">About Shopie Bazar</h3>
                    <p className="footer-description">
                        Your trusted online marketplace for quality products at competitive prices. 
                        {/* We connect buyers and sellers across India with a seamless shopping experience. */}
                    </p>
                    <div className="footer-links">
                        <a href="/privacy" className="footer-link">Privacy Policy</a>
                        <a href="/terms" className="footer-link">Terms of Use</a>
                        <a href="/returns-refunds" className="footer-link">Refund & Cancellation</a>
                        <a href="/shipping-policy" className="footer-link">Shipping Policy</a>
                        <a href="/data-deletion" className="footer-link">Delete Account</a>
                    </div>
                </div>

                {/* Quick Links Column */}
                <div className="footer-column">
                    <h3 className="footer-title">Quick Links</h3>
                    <ul className="footer-menu">
                        <li><a href="/" className="footer-link">Home</a></li>
                        <li><a href="/about" className="footer-link">About</a></li>
                        <li><a href="/categories" className="footer-link">Categories</a></li>
                        <li><a href="/cart" className="footer-link">Shopping Cart</a></li>
                        <li><a href="/signin" className="footer-link">Sign In</a></li>
                        <li><a href="/register" className="footer-link">Register</a></li>
                        <li><a href="https://seller.shopiebazar.com" target="_blank" rel="noreferrer" className="footer-link">Become Seller</a></li>
                        {/* <li><a href="https://seller.shopiebazar.com/login" target="_blank" rel="noopener noreferrer" className="footer-link">Seller Login</a></li> */}
                    </ul>
                </div>

                {/* Customer Support Column */}
                <div className="footer-column">
                    <h3 className="footer-title">Customer Support</h3>
                    <ul className="footer-menu">
                        <li><a href="/help" className="footer-link">Help Center</a></li>
                        <li><a href="#" className="footer-link">Track Your Order</a></li>
                        {/* Policies grouped in the first column */}
                        <li><a href="#" className="footer-link">FAQ</a></li>
                        <li><a href="/contact" className="footer-link">Contact Us</a></li>
                    </ul>
                </div>

                {/* Contact Info Column */}
                <div className="footer-column contact-column">
                    <h3 className="footer-title">Contact Us</h3>
                    <div className="contact-info">
                        <div className="contact-item">
                            <div className="contact-icon">🏢</div>
                            <div className="contact-details">
                                <strong>SHOPIE TECHNOLOGIES PVT. LTD.</strong>
                            </div>
                        </div>
                        
                        <div className="contact-item">
                            <div className="contact-icon">📍</div>
                            <div className="contact-details">
                                A 19, Ground Floor FIEE Complex,<br/>
                                Okhla Phase II, Okhla Industrial Estate,<br/>
                                New Delhi, India - 110020
                            </div>
                        </div>
                        
                        <div className="contact-item">
                            <div className="contact-icon">📞</div>
                            <div className="contact-details">
                                <a href="tel:+911169266020" className="contact-link">+91 1169266020</a><br/>
                                <a href="tel:+911169266020" className="contact-link">+91 1169266020</a>
                            </div>
                        </div>
                        
                        <div className="contact-item">
                            <div className="contact-icon">✉️</div>
                            <div className="contact-details">
                                <a href="mailto:support@shopiebazar.com" className="contact-link">
                                    support@shopiebazar.com
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Footer Bottom */}
            <div className="footer-bottom">
                <div className="footer-container">
                    <div className="footer-bottom-content">
                        <p>&copy; {new Date().getFullYear()} Shopie Technologies Pvt. Ltd. All rights reserved.</p>
                        <div className="social-links">
                            <span>Follow us:</span>
                            <a href="https://www.facebook.com/profile.php?id=61577274590767" target="_blank" className="social-link" aria-label="Facebook">
                                <FontAwesomeIcon icon={faFacebook} />
                            </a>
                            <a href="https://www.instagram.com/shopiebazar" target="_blank" className="social-link" aria-label="Instagram">
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>
                            {/* <a href="https://twitter.com/shopiebazar" target="_blank" className="social-link" aria-label="Twitter">
                                <FontAwesomeIcon icon={faTwitter} />
                            </a> */}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
